import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { default as axios } from '../axiosConfig';
import ReCAPTCHA from 'react-google-recaptcha'; // Add ReCAPTCHA for bot protection
import { Box, TextField, Button, Typography, CircularProgress } from '@mui/material';
import { API_RequestPasswordReset } from '../Assets/ApiUrlContainer';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [recaptchaToken, setRecaptchaToken] = useState(null); // Store the reCAPTCHA token
  const [captchaError, setCaptchaError] = useState(false); // Handle reCAPTCHA error
  const navigate = useNavigate();

  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY; // Add your reCAPTCHA site key in .env

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    setCaptchaError(false);

    if (!recaptchaToken) {
      setCaptchaError(true);
      setLoading(false);
      return;
    }

    try {
      // Include the recaptchaToken in the request
      const response = await axios.post(API_RequestPasswordReset, { email, captchaToken: recaptchaToken });
      setMessage(response.data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token); // Update the token on successful verification
    setCaptchaError(false); // Clear any previous CAPTCHA error
  };

  return (
    <Box style={{ padding: '20px', maxWidth: '400px', margin: 'auto', textAlign: 'center' }}>
      <Typography variant="h5">Forgot Password</Typography>
      <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          required
          style={{ margin: '20px 0' }}
        />
        <ReCAPTCHA
          sitekey={siteKey} // Use the environment variable for your reCAPTCHA site key
          onChange={handleRecaptchaChange}
          style={{ marginBottom: '20px' }}
        />
        {captchaError && <Typography color="error">Please complete the CAPTCHA</Typography>}
        {loading ? (
          <CircularProgress />
        ) : (
          <Button type="submit" variant="contained" color="primary" fullWidth>
            Reset Password
          </Button>
        )}
      </form>
      {message && <Typography color="green">{message}</Typography>}
      {error && <Typography color="red">{error}</Typography>}
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleBackToHome}
        style={{ marginTop: '20px' }}
        fullWidth
      >
        Back to Home
      </Button>
    </Box>
  );
};

export default ForgotPasswordPage;